import { StandardEvents } from '@shopify/events';
import { initializeYourassetCheckout, syncVariant, syncCartRoot } from '@theme/yourasset-checkout';
let cartGeneration = 0;
const variantGenerations = new WeakMap();
document.addEventListener(StandardEvents.productSelect, async event => {
  const scope = event.target.closest('.shopify-section');
  if (!scope) return;
  const generation = (variantGenerations.get(scope) || 0) + 1;
  variantGenerations.set(scope, generation);
  const roots = [...scope.querySelectorAll('[data-yourasset-checkout]:not([data-source-surface])')];
  roots.forEach(root => {root.hidden = true;});
  try {
    const {detail} = await event.promise;
    if (variantGenerations.get(scope) !== generation) return;
    for (const root of roots) {
      const source = [...(detail?.html?.querySelectorAll('[data-yourasset-checkout]') || [])].find(node => node.dataset.productId === root.dataset.productId && node.dataset.sectionId === root.dataset.sectionId);
      if (source) syncVariant(root, source);
    }
  } catch { /* Pending/error must remain ineligible. */ }
});
document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  const generation = ++cartGeneration;
  try {
    // A rejected quantity change can leave a valid cart (for example stock = 1).
    // Re-prove eligibility from the fresh cart, never from the failed mutation.
    try { await event.promise; } catch { /* The cart read below remains authoritative. */ }
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}});
    if (!response.ok) throw Error('Cart unavailable');
    const cart = await response.json();
    if (generation !== cartGeneration) return;
    document.querySelectorAll('[data-yourasset-checkout][data-source-surface^="cart"]').forEach(root => syncCartRoot(root, cart));
    initializeYourassetCheckout();
  } catch {
    if (generation === cartGeneration) document.querySelectorAll('[data-yourasset-checkout][data-source-surface^="cart"]').forEach(root => {root.hidden = true;});
  }
});
